<p class="info info--ok" translate>auth.recoverPassword.success</p>
<p class="recover-link"><a [routerLink]="['/login']" translate>auth.recoverPassword.backToLogin</a></p>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/recover-password/recover-password-done/recover-password-done.component.html